import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import { TabContent } from 'carbon-components-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FW_PREFIX } from '../../../shared/constants/generalConstants.js';

var _excluded = ["className", "backgroundKind"];
var TABCONTENT_BACKGROUNDKIND = {
  White: 'white',
  Gray: 'gray'
};
var IlTabContent = /*#__PURE__*/function (_Component) {
  function IlTabContent() {
    _classCallCheck(this, IlTabContent);
    return _callSuper(this, IlTabContent, arguments);
  }
  _inherits(IlTabContent, _Component);
  return _createClass(IlTabContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        backgroundKind = _this$props.backgroundKind,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var newProps = _objectSpread2(_objectSpread2({}, rest), {}, {
        className: classNames("".concat(FW_PREFIX, "__IlTabContent"), "".concat(FW_PREFIX, "__IlTabContent-").concat(backgroundKind), className)
      });
      return /*#__PURE__*/React__default.createElement(TabContent, newProps);
    }
  }]);
}(Component);
_defineProperty(IlTabContent, "propTypes", _objectSpread2(_objectSpread2({}, TabContent.propTypes), {}, {
  backgroundKind: PropTypes.oneOf(_toConsumableArray(Object.values(TABCONTENT_BACKGROUNDKIND)))
}));
_defineProperty(IlTabContent, "defaultProps", {
  backgroundKind: TABCONTENT_BACKGROUNDKIND.Gray
});

export { IlTabContent, TABCONTENT_BACKGROUNDKIND };
